$(document).ready(function () {
  function initSlider($slider) {
    const sliderSettings = JSON.parse(
      $slider.data("slider-settings").replaceAll("'", '"')
    );
    console.log(sliderSettings);
    $slider.slick({
      arrows: false,
      autoplay: sliderSettings.autoplay,
      autoplaySpeed: sliderSettings.autoplaySpeed,
    });
  }

  $(".brand-slider").each(function () {
    initSlider($(this));
  });

  document.addEventListener("shopify:section:load", function (event) {
    $(".brand-slider").each(function () {
      var $slider = $(this);

      if ($slider.data("sec-id") == event.detail.sectionId) {
        initSlider($slider);
      }
    });
  });
});
